import { getPeriodStatus } from '@/helpers/periodStatus';

interface OfferGroupTitle {
  group_key: string;
  title: string;
  collection_type?: string;
}

interface OfferGroupProduct {
  id: string;
  groupKey: string;
}

interface PeriodProduct {
  valid_from?: string;
  valid_to?: string;
  stina_product_id?: string;
}

export const stinaProductIdFromGroupKey = (groupKey: string): string | null => {
  const underscoreIndex = groupKey.indexOf('_');
  if (underscoreIndex === -1) return null;
  const productId = groupKey.slice(underscoreIndex + 1);
  return productId.length > 0 ? productId : null;
};

export const staticTicketTitle = (
  stinaProductId: string | undefined,
  offers: OfferGroupTitle[] | undefined,
  collectionType?: string,
): string | undefined => {
  if (!stinaProductId || !offers?.length) return undefined;
  const matches = offers.filter(
    (offer) => stinaProductIdFromGroupKey(offer.group_key) === stinaProductId,
  );
  if (matches.length === 0) return undefined;
  if (!collectionType) return matches[0]?.title;
  return (
    matches.find((offer) => offer.collection_type === collectionType)?.title ??
    matches[0]?.title
  );
};

/** Offer groups whose product is stored on an active or upcoming period. */
export const offerGroupIdsUsedByActiveOrUpcomingPeriods = (
  offerGroups: OfferGroupProduct[],
  claims: PeriodProduct[],
): string[] => {
  const usedProductIds = new Set<string>();
  for (const claim of claims) {
    if (!claim.stina_product_id) continue;
    if (getPeriodStatus(claim) === 'past') continue;
    usedProductIds.add(claim.stina_product_id);
  }
  if (usedProductIds.size === 0) return [];

  return offerGroups.flatMap((group) => {
    const productId = stinaProductIdFromGroupKey(group.groupKey);
    if (!productId || !usedProductIds.has(productId)) return [];
    return [group.id];
  });
};
